define('businessServices/numberProvisioning/phoneNumberResult',[],function() {
    return function(){
        var self = this;

        self.phoneNumber = null;
    };
});

